import { defineMessages } from 'react-intl';

export default defineMessages({
    esignHeading: {
        id: 'ml.common.component.esignature.heading',
        defaultMessage: 'eSignature Preferences'
    },
    esign: {
        id: 'ml.common.component.esignature.esign',
        defaultMessage: 'eSign'
    },
    esignOptions: {
        id: 'ml.common.component.esignature.esignOptions',
        defaultMessage: 'eSignature Options'
    },
    esignOptionMobileNumber: {
        id: 'ml.common.component.esignature.esignOptionMobileNumber',
        defaultMessage: 'Mobile Number ( Primary Insured )'
    },
    agentSalesAcknowledgement: {
        id: 'ml.common.component.esignature.agentSalesAcknowledgement',
        defaultMessage: 'A vendor will send the applicant a text message containing a link to sign the documents. A vendor may also send future text messages related to this program, and standard SMS rates may apply. The applicant may opt out of future text messages from a vendor at any time. Does the applicant consent to sharing the mobile phone number provided with a vendor to facilitate participation in signing documents for this program?'
    },
    directSalesAcknowledgement: {
        id: 'ml.common.component.esignature.directSalesAcknowledgement',
        defaultMessage: 'A vendor will send you a text message containing a link to sign the documents. A vendor may also send future text messages related to this program, and standard SMS rates may apply. You may opt out of future text messages from a vendor at any time. Do you consent to sharing the mobile phone number you provided with a vendor to facilitate participation in signing documents for this program?'
    },
    requiredField: {
        id: 'ml.common.component.esignature.Required field',
        defaultMessage: 'This field is required'
    }
});
